import { gql } from '@apollo/client';

// ─── Subscription Operations ────────────────────────────────────────────────

export const VENDOR_OPPORTUNITY_UPDATED = gql`
  subscription VendorOpportunityUpdated($vendorOpportunityId: ID!) {
    vendorOpportunityUpdated(vendorOpportunityId: $vendorOpportunityId) {
      id
      stage
      dealStatus
      potentialFinanceAmount
    }
  }
`;

export const NOTIFICATION_RECEIVED = gql`
  subscription NotificationReceived($userProfileId: ID!) {
    notificationReceived(userProfileId: $userProfileId) {
      id
      userProfileId
      title
      message
      type
      entityId
      entityType
      createdAt
    }
  }
`;

export const CREDIT_SUBMISSION_UPDATED = gql`
  subscription CreditSubmissionUpdated($vendorOpportunityId: ID!) {
    creditSubmissionUpdated(vendorOpportunityId: $vendorOpportunityId) {
      id
      status
      submissionId
    }
  }
`;

export const DEAL_ACTIVITY_UPDATED = gql`
  subscription DealActivityUpdated($vendorOpportunityId: ID!) {
    dealActivityUpdated(vendorOpportunityId: $vendorOpportunityId) {
      id
      vendorOpportunityId
      type
      subject
      description
      createdBy
      createdAt
    }
  }
`;

export const AI_DECISION_PARSING_COMPLETED = gql`
  subscription AiDecisionParsingCompleted($creditSubmissionId: ID!) {
    aiDecisionParsingCompleted(creditSubmissionId: $creditSubmissionId) {
      creditSubmissionId
      documentId
      success
      errorMessage
      completedAt
    }
  }
`;

export const SMS_ACTIVITY_RECEIVED = gql`
  subscription SmsActivityReceived($vendorOpportunityId: ID!) {
    smsActivityReceived(vendorOpportunityId: $vendorOpportunityId) {
      id
      vendorOpportunityId
      message
      smsDirection
      status
      twilioMessageId
      twilioConversationSid
      createdAt
    }
  }
`;
